<template>
  <aside class="sticky top-0 hidden h-screen w-64 flex-none flex-col border-r border-default bg-default lg:flex">
    <div class="relative flex-none overflow-hidden border-b border-default px-4 pt-4 pb-3">
      <div class="pointer-events-none absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-primary via-info to-primary" />
      <div class="relative flex items-center gap-3">
        <div class="flex size-10 flex-none items-center justify-center rounded-xl bg-default shadow-sm ring-1 ring-default">
          <img :src="meltalIcon" alt="Meltal" class="size-7 object-contain" />
        </div>
        <div>
          <div class="text-base leading-tight font-bold text-highlighted">{{ t('app.name') }}</div>
          <div class="text-xs text-muted">{{ t('app.tagline') }}</div>
        </div>
      </div>
    </div>

    <div class="min-h-0 flex-1 p-3">
      <NavMenu />
    </div>

    <div class="flex-none p-3 pt-0">
      <SessionCard />
    </div>
  </aside>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

import meltalIcon from '@/assets/meltal-icon.png'
import NavMenu from './NavMenu.vue'
import SessionCard from './SessionCard.vue'

const { t } = useI18n()
</script>
